import { useLocation, useMatches } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { useAuthStore } from "src/auth";

export function useBaseStaticCtx() {
  const authStore = useAuthStore();
  const { i18n } = useTranslation();
  const location = useLocation();
  const pathname = useMatches({
    select: (matches) => {
      return matches[matches.length - 1].pathname.replace(/(.)\/$/, "$1");
    },
  });

  return {
    i18n,
    session: authStore._authenticatedData,
    location,
    pathname,
  };
}
